$(document).ready(function () {
    const boxOptions = $(".box_option");
    const mainPrices = $(".product-main-price");
    boxOptions.on("click", function () {
        boxOptions.removeClass("active");
        $(this).addClass("active");
        var title = $(this).data("title");
        var price = $(this).data("price");
        var price10 = $(this).data("price10");
        var cp = $(this).data("cp");
                if( title == '1 Set' ){
                    $('.rc_widget__price--onetime').html(`${price}`);
                }else{
                    $('.rc_widget__price--onetime').html(`${price} <s>${cp}</s>`);
                }
                const isChecked = document.querySelector('.rc_widget__option__input--subsave').checked;
                if (isChecked) {
                $('.product-btn-price').html(price10);
                }else{
                $('.product-btn-price').html(`${price}`);
                }
                $('.rc_widget__price--subsave').html(`${price10} <s>${cp}</s>`);
                mainPrices.html(price);

    });

    $(document).on('click', '.rc_widget__option__label', function() {
        setTimeout(function() {   
            var title = $('.box_option.active').data("title");
            const price = $('.box_option.active').data("price");
            var cp = $('.box_option.active').data("cp");
            var price10 = $('.box_option.active').data("price10");           
                if( title == '1 Set' ){
                        $('.rc_widget__price--onetime').html(`${price}`);
                    }else{
                        $('.rc_widget__price--onetime').html(`${price} <s>${cp}</s>`);
                    }

                    const isChecked = document.querySelector('.rc_widget__option__input--subsave').checked;
                    if (isChecked) {
                        $('.product-btn-price').html(price10);
                    }else{
                    $('.product-btn-price').html(`${price}`);
                    }
                    $('.rc_widget__price--subsave').html(`${price10} <s>${cp}</s>`);
                    mainPrices.html(price);
            
}, 500);
    });

        $(document).on('change', '.rc-selling-plans__dropdown', function() {
            setTimeout(function() {   
                var title = $('.box_option.active').data("title");
                const price = $('.box_option.active').data("price");
                var cp = $('.box_option.active').data("cp");
                var price10 = $('.box_option.active').data("price10");        
                if( title == '1 Set' ){
                            $('.rc_widget__price--onetime').html(`${price}`);
                        }else{
                            $('.rc_widget__price--onetime').html(`${price} <s>${cp}</s>`);
                        }
                        const isChecked = document.querySelector('.rc_widget__option__input--subsave').checked;
                        if (isChecked) {
                        $('.product-btn-price').html(price10);
                        }else{
                        $('.product-btn-price').html(`${price}`);
                        }
                        $('.rc_widget__price--subsave').html(`${price10} <s>${cp}</s>`);
                        mainPrices.html(price);
                
    }, 500);
    });

 

    $(document).on('click', '.addToCart-btn', function(event){
        event.preventDefault();
         var id = $('.box_option.active').data('id');
         var qty = 1;
         var selling_plan = $('[name="selling_plan"]').val();
        //  console.log(selling_plan);
         if(selling_plan){
            var data = JSON.stringify({
                items: [
                  {
                    id: id,
                     quantity: qty,
                    selling_plan: selling_plan
                  }
                ],
                sections: "custom-cart-drawer"
              });
         }else{
            var data = JSON.stringify({
                items: [
                  {
                    id: id,
                     quantity: qty
                  }
                ],
                sections: "custom-cart-drawer"
              });
         }

          addToCart(data);
      });




      

  waitUntilExists(".rc-container-wrapper.rc_container_wrapper").then(element => {
    console.log("Elemento encontrado:", element);
    
    return waitUntilExists(".prod_subsription_box .box_options_wrapper").then(target => {
      console.log("Target encontrado:", target);

      // Insertar el widget como el siguiente sibling de `.prod_subscription_box .box_options_wrapper`
      target.parentNode.insertBefore(element, target.nextSibling);
      console.log("Elemento movido exitosamente.");
      setTimeout(function() {   
      var cp = $('.box_option.active').data("cp");
      var price10 = $('.box_option.active').data("price10");     
      $('.rc_widget__price--subsave').html(`${price10} <s>${cp}</s>`);
      console.log("Elemento movido exitosamente.");
      },200);
    });
  }).catch(error => {
    console.error("Error al buscar el elemento:", error);
  });


function waitUntilExists(selector) {
    try {
        return new Promise( resolve => {
      if(document.querySelector(selector))
        return resolve(document.querySelector(selector));
      const observer = new MutationObserver(mutuations => {
        if (document.querySelector(selector)) {
          resolve(document.querySelector(selector))
          observer.disconnect();
        }		
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
        });
    } catch(e) { console.error(e); }
}

});


